export enum StatementStateEnum {
    OPEN = "OPEN",
    ARCHIVED = "ARCHIVED"
}